import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Translate } from "react-localize-redux";
import { recoverAccountByEmailAction } from "../../../redux/actions/accountRecovery.actions";

const RecoverAccountByEmailPage = ({ email, recoverAccountByEmailAction }) => (
  <div
    id="page-container"
    className="row align-items-center justify-content-center"
  >
    <div className="col-lg-4 text-center">
      <h3 id="sign-in-brand">
        <Translate id="passwordReset" />
      </h3>
      <p>
        We'll email instructions for setting a new password to the below
        address:
      </p>
      <br />
      <h5>{email}</h5>
      <br />
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => recoverAccountByEmailAction(email)}
      >
        Reset my password
      </button>
    </div>
  </div>
);

const mapStateToProps = ({ accountRecovery }) => ({
  email:
    accountRecovery.selectedAccount && accountRecovery.selectedAccount.email
});

export default withRouter(
  connect(
    mapStateToProps,
    { recoverAccountByEmailAction }
  )(RecoverAccountByEmailPage)
);



// WEBPACK FOOTER //
// ./src/components/pages/RecoverAccountByEmailPage/RecoverAccountByEmailPage.jsx